import React from 'react';
import MuiButton, { ButtonProps } from '@material-ui/core/Button';

const ButtonWithDefaults: React.FC<React.PropsWithChildren<ButtonProps>> = ({ children, ...rest }) => (
  <>
    {/* @ts-ignore: Provide better description why we use ts-ignore here */}
    <MuiButton variant="contained" {...rest}>
      {children}
    </MuiButton>
  </>
);

export const PrimaryButton = {
  Outlined: (props: Partial<Omit<ButtonProps, 'variant' | 'color' | 'css'>>) => (
    <ButtonWithDefaults variant="outlined" color="primary" {...props} />
  ),
  Contained: (props: Partial<Omit<ButtonProps, 'variant' | 'color' | 'css'>>) => (
    <ButtonWithDefaults variant="contained" color="primary" {...props} />
  ),
  Text: (props: Partial<Omit<ButtonProps, 'variant' | 'color' | 'css'>>) => (
    <ButtonWithDefaults variant="text" color="primary" {...props} />
  )
} as const;

export const DefaultButton = {
  Outlined: (props: Partial<Omit<ButtonProps, 'variant' | 'color' | 'css'>>) => (
    <ButtonWithDefaults variant="outlined" color="default" {...props} />
  ),
  Contained: (props: Partial<Omit<ButtonProps, 'variant' | 'color' | 'css'>>) => (
    <ButtonWithDefaults variant="contained" color="default" {...props} />
  ),
  Text: (props: Partial<Omit<ButtonProps, 'variant' | 'color' | 'css'>>) => (
    <ButtonWithDefaults variant="text" color="default" {...props} />
  )
} as const;

export const Button = (props: Partial<Omit<ButtonProps, 'css'>>) => (
  <ButtonWithDefaults variant="outlined" {...props} />
);
